import React from 'react';
import ModalRoot from './components/common/ModalRoot';
import ToastsContainer from './components/toastsContainer';
import NavContainer from './components/navV2/NavContainer';
import FeatureToggle from './components/FeatureToggle';
import BookingStatusReminderContainer from './components/BookingStatusReminder';
import PostWeddingCelebration from './components/PostWeddingCelebration';

import featureFlags from './util/featureFlags';

const showFeatureToggle = featureFlags.get('featureToggle');
const showBookingStatusReminder = featureFlags.get('bookingStatusReminder');

function App() {
  return (
    <React.Fragment>
      <a href="/webaccessibility" tabIndex="0" className="accessibility-link screen-only">
        Web Accessibility
      </a>
      <NavContainer />
      <ModalRoot />
      {showBookingStatusReminder && <BookingStatusReminderContainer />}
      <ToastsContainer />
      {showFeatureToggle && <FeatureToggle />}
      <PostWeddingCelebration />
    </React.Fragment>
  );
}

export default App;
